export type OrderSource = 'direct' | 'package';
export type Priority = 'normal' | 'urgent';
export type OrderStatus =
  | 'pending'
  | 'accepted'
  | 'processing'
  | 'ready'
  | 'completed'
  | 'cancelled'
  | 'rejected'
  | 'needs_driver';

export interface OrderLineItem {
  id: string;
  name: string;
  service: string;
  quantity: number;
  priceEach: number;
}

export interface OrderHistoryEvent {
  status: OrderStatus;
  label: string;
  date: string;
  time: string;
}

export interface Order {
  id: string;
  orderNo: string;
  customer: string;
  phone: string;
  district: string;
  address: string;
  piecesCount: number;
  serviceType: string;
  priority: Priority;
  deliveryMethod: string;
  source: OrderSource;
  amount: number;
  status: OrderStatus;
  date: string;
  time: string;
  driverId?: string;
  items: OrderLineItem[];
  subtotal: number;
  deliveryFees: number;
  discount: number;
  total: number;
  coupon?: { code: string; value: number };
  notes: string;
  history: OrderHistoryEvent[];
}

export const ordersList: Order[] = [
  {
    id: 'ORD-98756',
    orderNo: '#98756',
    customer: 'نورة العتيبي',
    phone: '0551234567',
    district: 'الياسمين',
    address: 'شارع الأمير سلطان، مبنى 12، الدور الثالث',
    piecesCount: 5,
    serviceType: 'غسيل وكوي',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 185,
    status: 'pending',
    date: '2026-09-16',
    time: '04:12 م',
    items: [
      { id: 'L1', name: 'قميص رجالي', service: 'غسيل وكوي', quantity: 3, priceEach: 25 },
      { id: 'L2', name: 'بنطلون قماش', service: 'غسيل وكوي', quantity: 2, priceEach: 30 },
    ],
    subtotal: 135,
    deliveryFees: 15,
    discount: 0,
    total: 185,
    notes: 'الرجاء عدم استخدام معطر قوي',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '04:12 م' },
    ],
  },
  {
    id: 'ORD-98755',
    orderNo: '#98755',
    customer: 'عبدالله الشمري',
    phone: '0567891234',
    district: 'الملز',
    address: 'طريق الملك عبدالعزيز، فيلا 8',
    piecesCount: 5,
    serviceType: 'غسيل فقط',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'package',
    amount: 140,
    status: 'pending',
    date: '2026-09-16',
    time: '03:48 م',
    items: [
      { id: 'L1', name: 'ثوب رجالي', service: 'غسيل فقط', quantity: 4, priceEach: 18 },
      { id: 'L2', name: 'عباية', service: 'غسيل فقط', quantity: 1, priceEach: 25 },
    ],
    subtotal: 122,
    deliveryFees: 18,
    discount: 0,
    total: 140,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-16', time: '03:48 م' },
    ],
  },
  {
    id: 'ORD-98754',
    orderNo: '#98754',
    customer: 'سارة القحطاني',
    phone: '0509876543',
    district: 'الورود',
    address: 'شارع العروبة، برج الياقوت، شقة 41',
    piecesCount: 3,
    serviceType: 'كوي فقط',
    priority: 'urgent',
    deliveryMethod: 'استلام فقط',
    source: 'direct',
    amount: 210,
    status: 'pending',
    date: '2026-09-16',
    time: '03:05 م',
    items: [
      { id: 'L1', name: 'فستان سواريه', service: 'كوي فقط', quantity: 1, priceEach: 45 },
      { id: 'L2', name: 'جاكيت', service: 'كوي فقط', quantity: 2, priceEach: 30 },
    ],
    subtotal: 105,
    deliveryFees: 15,
    discount: 0,
    total: 210,
    notes: 'كوي بحرارة منخفضة',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '03:05 م' },
    ],
  },
  {
    id: 'ORD-98752',
    orderNo: '#98752',
    customer: 'محمد الدوسري',
    phone: '0533456789',
    district: 'الغدير',
    address: 'شارع التخصصي، مبنى 25',
    piecesCount: 3,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 165,
    status: 'pending',
    date: '2026-09-16',
    time: '02:30 م',
    items: [
      { id: 'L1', name: 'مفرش سرير كبير', service: 'غسيل وكوي', quantity: 2, priceEach: 45 },
      { id: 'L2', name: 'بدلة كاملة', service: 'غسيل وكوي', quantity: 1, priceEach: 55 },
    ],
    subtotal: 145,
    deliveryFees: 20,
    discount: 0,
    total: 165,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '02:30 م' },
    ],
  },
  {
    id: 'ORD-98750',
    orderNo: '#98750',
    customer: 'هند المطيري',
    phone: '0576543210',
    district: 'حطين',
    address: 'شارع أنس بن مالك، فيلا 3',
    piecesCount: 6,
    serviceType: 'غسيل فقط',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'package',
    amount: 150,
    status: 'pending',
    date: '2026-09-16',
    time: '01:55 م',
    items: [{ id: 'L1', name: 'قميص رجالي', service: 'غسيل فقط', quantity: 6, priceEach: 18 }],
    subtotal: 108,
    deliveryFees: 15,
    discount: 0,
    total: 150,
    notes: 'يرجى فصل الأبيض عن الملون',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-16', time: '01:55 م' },
    ],
  },
  {
    id: 'ORD-98747',
    orderNo: '#98747',
    customer: 'فهد العنزي',
    phone: '0552221199',
    district: 'المروج',
    address: 'شارع الأمير نايف، مبنى 44',
    piecesCount: 4,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 195,
    status: 'processing',
    date: '2026-09-16',
    time: '11:20 ص',
    driverId: 'DRV-102',
    items: [
      { id: 'L1', name: 'بشت', service: 'غسيل وكوي', quantity: 1, priceEach: 70 },
      { id: 'L2', name: 'ثوب رجالي', service: 'غسيل وكوي', quantity: 3, priceEach: 25 },
    ],
    subtotal: 145,
    deliveryFees: 15,
    discount: 0,
    total: 195,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '09:40 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-16', time: '09:52 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '11:20 ص' },
    ],
  },
  {
    id: 'ORD-98744',
    orderNo: '#98744',
    customer: 'ريم السبيعي',
    phone: '0559998877',
    district: 'الربيع',
    address: 'شارع الإمام سعود، مبنى 9',
    piecesCount: 7,
    serviceType: 'كوي فقط',
    priority: 'urgent',
    deliveryMethod: 'استلام فقط',
    source: 'direct',
    amount: 240,
    status: 'processing',
    date: '2026-09-16',
    time: '10:10 ص',
    driverId: 'DRV-101',
    items: [
      { id: 'L1', name: 'قميص رجالي', service: 'كوي فقط', quantity: 5, priceEach: 15 },
      { id: 'L2', name: 'بنطلون قماش', service: 'كوي فقط', quantity: 2, priceEach: 18 },
    ],
    subtotal: 111,
    deliveryFees: 0,
    discount: 0,
    total: 240,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '08:30 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-16', time: '08:41 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '10:10 ص' },
    ],
  },
  {
    id: 'ORD-98741',
    orderNo: '#98741',
    customer: 'خالد الغامدي',
    phone: '0544332211',
    district: 'النرجس',
    address: 'شارع وادي النرجس، فيلا 21',
    piecesCount: 6,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'package',
    amount: 175,
    status: 'ready',
    date: '2026-09-16',
    time: '09:05 ص',
    driverId: 'DRV-103',
    items: [
      { id: 'L1', name: 'بطانية', service: 'غسيل وكوي', quantity: 1, priceEach: 60 },
      { id: 'L2', name: 'ثوب رجالي', service: 'غسيل وكوي', quantity: 4, priceEach: 25 },
    ],
    subtotal: 160,
    deliveryFees: 15,
    discount: 0,
    total: 175,
    notes: 'جاهز للاستلام من الفرع',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-15', time: '06:20 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-15', time: '06:35 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '07:00 ص' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-16', time: '09:05 ص' },
    ],
  },
  {
    id: 'ORD-98739',
    orderNo: '#98739',
    customer: 'منيرة الشهري',
    phone: '0556677889',
    district: 'القيروان',
    address: 'شارع الملك عبدالله، مبنى 30',
    piecesCount: 9,
    serviceType: 'غسيل فقط',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 210,
    status: 'ready',
    date: '2026-09-16',
    time: '08:40 ص',
    driverId: 'DRV-105',
    items: [
      { id: 'L1', name: 'مفرش سرير كبير', service: 'غسيل فقط', quantity: 3, priceEach: 35 },
      { id: 'L2', name: 'قميص رجالي', service: 'غسيل فقط', quantity: 6, priceEach: 16 },
    ],
    subtotal: 201,
    deliveryFees: 9,
    discount: 0,
    total: 210,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-15', time: '05:10 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-15', time: '05:22 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '06:45 ص' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-16', time: '08:40 ص' },
    ],
  },
  {
    id: 'ORD-98733',
    orderNo: '#98733',
    customer: 'طلال الرشيد',
    phone: '0501234567',
    district: 'الصحافة',
    address: 'شارع التخصصي، مبنى 77',
    piecesCount: 4,
    serviceType: 'غسيل وكوي',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 320,
    status: 'needs_driver',
    date: '2026-09-16',
    time: '12:15 م',
    items: [
      { id: 'L1', name: 'بدلة كاملة', service: 'غسيل وكوي', quantity: 2, priceEach: 75 },
      { id: 'L2', name: 'قميص رجالي', service: 'غسيل وكوي', quantity: 2, priceEach: 28 },
    ],
    subtotal: 206,
    deliveryFees: 20,
    discount: 0,
    total: 320,
    notes: 'العميل ينتظر مندوب التسليم',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '07:30 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-16', time: '07:44 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '09:00 ص' },
      { status: 'needs_driver', label: 'بانتظار تعيين مندوب تسليم', date: '2026-09-16', time: '12:15 م' },
    ],
  },
  {
    id: 'ORD-98729',
    orderNo: '#98729',
    customer: 'لمى البقمي',
    phone: '0554321000',
    district: 'الزهراء',
    address: 'شارع الأمير محمد، مبنى 5',
    piecesCount: 4,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'استلام فقط',
    source: 'direct',
    amount: 130,
    status: 'processing',
    date: '2026-09-16',
    time: '10:55 ص',
    driverId: 'DRV-104',
    items: [{ id: 'L1', name: 'فستان يومي', service: 'غسيل وكوي', quantity: 4, priceEach: 30 }],
    subtotal: 120,
    deliveryFees: 10,
    discount: 0,
    total: 130,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-16', time: '09:10 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-16', time: '09:20 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-16', time: '10:55 ص' },
    ],
  },
  {
    id: 'ORD-98724',
    orderNo: '#98724',
    customer: 'سلمان العمري',
    phone: '0556667778',
    district: 'قرطبة',
    address: 'شارع العليا العام، مبنى 18',
    piecesCount: 5,
    serviceType: 'كوي فقط',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'package',
    amount: 118,
    status: 'accepted',
    date: '2026-09-16',
    time: '09:35 ص',
    items: [
      { id: 'L1', name: 'ثوب رجالي', service: 'كوي فقط', quantity: 5, priceEach: 12 },
    ],
    subtotal: 100,
    deliveryFees: 18,
    discount: 0,
    total: 118,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-16', time: '08:50 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-16', time: '09:35 ص' },
    ],
  },
  {
    id: 'ORD-98718',
    orderNo: '#98718',
    customer: 'أمل الجهني',
    phone: '0503334444',
    district: 'الرمال',
    address: 'شارع الإمام الشافعي، فيلا 27',
    piecesCount: 8,
    serviceType: 'غسيل فقط',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 265,
    status: 'processing',
    date: '2026-09-15',
    time: '06:30 م',
    driverId: 'DRV-101',
    items: [
      { id: 'L1', name: 'بطانية', service: 'غسيل فقط', quantity: 2, priceEach: 55 },
      { id: 'L2', name: 'مفرش سرير كبير', service: 'غسيل فقط', quantity: 6, priceEach: 25 },
    ],
    subtotal: 260,
    deliveryFees: 5,
    discount: 0,
    total: 265,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-15', time: '03:00 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-15', time: '03:12 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-15', time: '06:30 م' },
    ],
  },
  {
    id: 'ORD-98711',
    orderNo: '#98711',
    customer: 'مشعل العتيبي',
    phone: '0557771122',
    district: 'الجزيرة',
    address: 'شارع الأمير تركي، مبنى 61',
    piecesCount: 3,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 205,
    status: 'ready',
    date: '2026-09-15',
    time: '05:40 م',
    driverId: 'DRV-103',
    items: [
      { id: 'L1', name: 'بشت', service: 'غسيل وكوي', quantity: 1, priceEach: 95 },
      { id: 'L2', name: 'ثوب رجالي', service: 'غسيل وكوي', quantity: 2, priceEach: 45 },
    ],
    subtotal: 185,
    deliveryFees: 20,
    discount: 0,
    total: 205,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-14', time: '07:20 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-14', time: '07:35 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-15', time: '09:00 ص' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-15', time: '05:40 م' },
    ],
  },
  {
    id: 'ORD-98699',
    orderNo: '#98699',
    customer: 'جواهر العنزي',
    phone: '0509988776',
    district: 'السلام',
    address: 'شارع الأمير سعود، فيلا 14',
    piecesCount: 5,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 148,
    status: 'completed',
    date: '2026-09-15',
    time: '02:15 م',
    driverId: 'DRV-102',
    items: [
      { id: 'L1', name: 'ثوب رجالي', service: 'غسيل وكوي', quantity: 4, priceEach: 25 },
      { id: 'L2', name: 'عباية', service: 'غسيل وكوي', quantity: 1, priceEach: 35 },
    ],
    subtotal: 135,
    deliveryFees: 13,
    discount: 0,
    total: 148,
    notes: 'تم التسليم بنجاح',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-14', time: '10:00 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-14', time: '10:15 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-14', time: '01:00 م' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-15', time: '11:00 ص' },
      { status: 'completed', label: 'تم تسليم الطلب للعميل', date: '2026-09-15', time: '02:15 م' },
    ],
  },
  {
    id: 'ORD-98691',
    orderNo: '#98691',
    customer: 'ناصر الحربي',
    phone: '0551119988',
    district: 'المنار',
    address: 'شارع الأمير فيصل، مبنى 52',
    piecesCount: 7,
    serviceType: 'غسيل فقط',
    priority: 'urgent',
    deliveryMethod: 'استلام فقط',
    source: 'package',
    amount: 190,
    status: 'completed',
    date: '2026-09-15',
    time: '12:50 م',
    driverId: 'DRV-105',
    items: [
      { id: 'L1', name: 'قميص رجالي', service: 'غسيل فقط', quantity: 7, priceEach: 18 },
    ],
    subtotal: 126,
    deliveryFees: 14,
    discount: 0,
    total: 190,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-14', time: '08:30 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-14', time: '08:45 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-15', time: '09:10 ص' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-15', time: '11:30 ص' },
      { status: 'completed', label: 'تم تسليم الطلب للعميل', date: '2026-09-15', time: '12:50 م' },
    ],
  },
  {
    id: 'ORD-98682',
    orderNo: '#98682',
    customer: 'بشاير القرني',
    phone: '0553334455',
    district: 'السليمانية',
    address: 'شارع الضباب، مبنى 8',
    piecesCount: 4,
    serviceType: 'كوي فقط',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 96,
    status: 'completed',
    date: '2026-09-14',
    time: '07:25 م',
    driverId: 'DRV-101',
    items: [{ id: 'L1', name: 'بنطلون قماش', service: 'كوي فقط', quantity: 4, priceEach: 20 }],
    subtotal: 80,
    deliveryFees: 16,
    discount: 0,
    total: 96,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-14', time: '02:00 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-14', time: '02:10 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-14', time: '04:00 م' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-14', time: '06:10 م' },
      { status: 'completed', label: 'تم تسليم الطلب للعميل', date: '2026-09-14', time: '07:25 م' },
    ],
  },
  {
    id: 'ORD-98670',
    orderNo: '#98670',
    customer: 'وليد السالم',
    phone: '0566665544',
    district: 'الشفا',
    address: 'شارع الحج، مبنى 33',
    piecesCount: 6,
    serviceType: 'غسيل وكوي',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 212,
    status: 'completed',
    date: '2026-09-14',
    time: '04:05 م',
    driverId: 'DRV-102',
    items: [
      { id: 'L1', name: 'مفرش سرير كبير', service: 'غسيل وكوي', quantity: 3, priceEach: 45 },
      { id: 'L2', name: 'بطانية', service: 'غسيل وكوي', quantity: 1, priceEach: 60 },
    ],
    subtotal: 195,
    deliveryFees: 17,
    discount: 0,
    total: 212,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-13', time: '11:20 ص' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-13', time: '11:35 ص' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-13', time: '02:00 م' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-14', time: '01:30 م' },
      { status: 'completed', label: 'تم تسليم الطلب للعميل', date: '2026-09-14', time: '04:05 م' },
    ],
  },
  {
    id: 'ORD-98658',
    orderNo: '#98658',
    customer: 'غادة المالكي',
    phone: '0542223366',
    district: 'العليا',
    address: 'شارع التحلية، برج المروج، شقة 12',
    piecesCount: 3,
    serviceType: 'غسيل فقط',
    priority: 'normal',
    deliveryMethod: 'استلام فقط',
    source: 'package',
    amount: 84,
    status: 'completed',
    date: '2026-09-13',
    time: '09:45 ص',
    driverId: 'DRV-103',
    items: [{ id: 'L1', name: 'قميص رجالي', service: 'غسيل فقط', quantity: 3, priceEach: 18 }],
    subtotal: 54,
    deliveryFees: 30,
    discount: 0,
    total: 84,
    notes: '-',
    history: [
      { status: 'pending', label: 'استلام الطلب داخل الباقة', date: '2026-09-12', time: '04:00 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-12', time: '04:20 م' },
      { status: 'processing', label: 'بدأ التنفيذ في المغسلة', date: '2026-09-13', time: '07:30 ص' },
      { status: 'ready', label: 'جاهز للتسليم', date: '2026-09-13', time: '08:30 ص' },
      { status: 'completed', label: 'تم تسليم الطلب للعميل', date: '2026-09-13', time: '09:45 ص' },
    ],
  },
  {
    id: 'ORD-98640',
    orderNo: '#98640',
    customer: 'إبراهيم النجار',
    phone: '0507778899',
    district: 'المرسلات',
    address: 'شارع العروبة، مبنى 70',
    piecesCount: 5,
    serviceType: 'غسيل وكوي',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 260,
    status: 'rejected',
    date: '2026-09-13',
    time: '01:10 م',
    items: [
      { id: 'L1', name: 'بدلة كاملة', service: 'غسيل وكوي', quantity: 2, priceEach: 85 },
      { id: 'L2', name: 'قميص رجالي', service: 'غسيل وكوي', quantity: 3, priceEach: 30 },
    ],
    subtotal: 260,
    deliveryFees: 0,
    discount: 0,
    total: 260,
    notes: 'رُفض لعدم تغطية الحي حالياً',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-13', time: '12:40 م' },
      { status: 'rejected', label: 'تم رفض الطلب وإعادة المبلغ', date: '2026-09-13', time: '01:10 م' },
    ],
  },
  {
    id: 'ORD-98625',
    orderNo: '#98625',
    customer: 'شهد الوقيان',
    phone: '0558889977',
    district: 'الياسمين',
    address: 'شارع أنس بن مالك، فيلا 40',
    piecesCount: 2,
    serviceType: 'كوي فقط',
    priority: 'normal',
    deliveryMethod: 'استلام فقط',
    source: 'direct',
    amount: 70,
    status: 'cancelled',
    date: '2026-09-12',
    time: '03:30 م',
    items: [{ id: 'L1', name: 'فستان سواريه', service: 'كوي فقط', quantity: 2, priceEach: 30 }],
    subtotal: 60,
    deliveryFees: 10,
    discount: 0,
    total: 70,
    notes: 'ألغى العميل الطلب',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-12', time: '02:50 م' },
      { status: 'cancelled', label: 'تم إلغاء الطلب بطلب من العميل', date: '2026-09-12', time: '03:30 م' },
    ],
  },
  {
    id: 'ORD-98611',
    orderNo: '#98611',
    customer: 'رائد الفيفي',
    phone: '0536665544',
    district: 'المروج',
    address: 'شارع الأمير نايف، مبنى 19',
    piecesCount: 4,
    serviceType: 'غسيل فقط',
    priority: 'normal',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 120,
    status: 'rejected',
    date: '2026-09-12',
    time: '11:05 ص',
    items: [{ id: 'L1', name: 'مفرش سرير كبير', service: 'غسيل فقط', quantity: 4, priceEach: 28 }],
    subtotal: 112,
    deliveryFees: 8,
    discount: 0,
    total: 120,
    notes: 'رُفض لتجاوز الطاقة الاستيعابية',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-12', time: '10:20 ص' },
      { status: 'rejected', label: 'تم رفض الطلب وإعادة المبلغ', date: '2026-09-12', time: '11:05 ص' },
    ],
  },
  {
    id: 'ORD-98600',
    orderNo: '#98600',
    customer: 'دانة العسيري',
    phone: '0551239876',
    district: 'النرجس',
    address: 'شارع وادي النرجس، فيلا 6',
    piecesCount: 3,
    serviceType: 'غسيل وكوي',
    priority: 'urgent',
    deliveryMethod: 'توصيل واستلام',
    source: 'direct',
    amount: 155,
    status: 'cancelled',
    date: '2026-09-11',
    time: '05:20 م',
    items: [
      { id: 'L1', name: 'عباية', service: 'غسيل وكوي', quantity: 1, priceEach: 45 },
      { id: 'L2', name: 'ثوب رجالي', service: 'غسيل وكوي', quantity: 2, priceEach: 40 },
    ],
    subtotal: 125,
    deliveryFees: 15,
    discount: 0,
    total: 155,
    notes: 'لم يتمكن المندوب من الوصول',
    history: [
      { status: 'pending', label: 'استلام الطلب من العميل', date: '2026-09-11', time: '03:00 م' },
      { status: 'accepted', label: 'تم قبول الطلب', date: '2026-09-11', time: '03:15 م' },
      { status: 'cancelled', label: 'تم إلغاء الطلب لتعذّر الاستلام', date: '2026-09-11', time: '05:20 م' },
    ],
  },
];

export const orderTabMeta = [
  { id: 'pending', label: 'جديدة', statuses: ['pending'] as OrderStatus[] },
  { id: 'active', label: 'جارية', statuses: ['accepted', 'processing', 'ready', 'needs_driver'] as OrderStatus[] },
  { id: 'completed', label: 'مكتملة', statuses: ['completed'] as OrderStatus[] },
  { id: 'cancelled', label: 'ملغاة', statuses: ['cancelled', 'rejected'] as OrderStatus[] },
];